import type { NextPage } from 'next'
import { ReactNode, MouseEventHandler } from 'react'
import classNames from 'classnames'
import styles from '../../styles/Column.module.scss'

interface Props {
  centerV?: boolean
  centerH?: boolean
  children?: ReactNode
  className?: string
  marginBottom?: boolean
  fullWidth?: boolean
  fixedHeight?: boolean
  onClick?: MouseEventHandler<HTMLDivElement>
  backgroundColor?: string
  gradient?: string
  padding?: boolean
  width?: string
  maxWidth?: string
  shadow?: boolean
}

const ColumnComponent: NextPage<Props> = (props: Props) => {
  const className = classNames(
    styles.container,
    props.centerV && styles.center_vertical,
    props.centerH && styles.center_horizontal,
    props.className,
    props.marginBottom && styles.margin_bottom,
    props.fullWidth && styles.fullWidth,
    props.fixedHeight && styles.fixed_height,
    props.gradient === "1" && styles.gradient_1,
    props.padding && styles.padding,
    props.shadow && styles.shadow
  )

  return (
    <div
      className={className}
      style={{ backgroundColor: props.backgroundColor, width: props.width, maxWidth: props.maxWidth }}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  )
}

export default ColumnComponent
